"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRxSubjectSubscribe = void 0;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const useRxSubjectEffect_1 = require("./useRxSubjectEffect");
const useRxSubjectSubscribe = (observable, { loadInitialValueAfterMount = true, hideLoadingFlag } = {}) => {
    const [value, setValue] = react_1.default.useState(() => {
        if (loadInitialValueAfterMount) {
            return hideLoadingFlag
                ? {}
                : {
                    loading: true,
                };
        }
        return Object.assign({ value: observable === null || observable === void 0 ? void 0 : observable.getValue() }, (!hideLoadingFlag && {
            loading: false,
        }));
    });
    (0, useRxSubjectEffect_1.useRxSubjectEffect)(observable, newValue => {
        setValue(oldState => {
            const newState = Object.assign({ value: newValue }, (!hideLoadingFlag && {
                loading: false,
            }));
            return (0, lodash_1.isEqual)(oldState, newState) ? oldState : newState;
        });
    }, { emitInitialValue: true });
    return value;
};
exports.useRxSubjectSubscribe = useRxSubjectSubscribe;
//# sourceMappingURL=useRxSubjectSubscribe.js.map